import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RestApiService {
  private http = inject(HttpClient);

  get<T>(
    url: string,
    params?: { [key: string]: string | number },
    headers?: { [key: string]: string }
  ): Observable<T> {
    const options = {
      headers: new HttpHeaders(headers),
      params: new HttpParams({ fromObject: params }),
      withCredentials: true, // Include cookies in cross-origin requests
    };

    return this.http.get<T>(url, options);
  }

  post<T>(
    url: string,
    body: any,
    headers?: { [key: string]: string }
  ): Observable<T> {
    const options = {
      headers: new HttpHeaders(headers),
      withCredentials: true, // Include cookies in cross-origin requests
    };

    return this.http.post<T>(url, body, options);
  }

  put<T>(
    url: string,
    body: any,
    headers?: { [key: string]: string }
  ): Observable<T> {
    const options = {
      headers: new HttpHeaders(headers),
      withCredentials: true, // Include cookies in cross-origin requests
    };

    return this.http.put<T>(url, body, options);
  }

  delete<T>(url: string, headers?: { [key: string]: string }): Observable<T> {
    const options = {
      headers: new HttpHeaders(headers),
      withCredentials: true, // Include cookies in cross-origin requests
    };

    return this.http.delete<T>(url, options);
  }
}
